import React from 'react';

import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { RemoveLuxuryHomesParams, RootState } from '@share/utils';
import { Routes } from '@share/constants';

import './style.scss';

interface IProps {
  route: string;
}

export const LuxuryHomesBack: React.FC<IProps> = ({ route }) => {
  const history = useHistory();

  const { account} = useSelector((state: RootState) => state.loginStore);

  const { propertyId } = useParams<{ propertyId: string }>();
  const { roomId } = useParams<{ roomId: string }>();
  const { placeId } = useParams<{ placeId: string }>();

  const onGoBack = () => {
    if (route === Routes.LuxuryHomes) {
      RemoveLuxuryHomesParams();
      
      history.push(`/${account?.name}${route}${location.search}`);
    } else if (route === Routes.LuxuryHomesDetails) {
      history.push(`/${account?.name}${route}/${propertyId}/${roomId}${location.search}`);
    } else if (route === Routes.LuxuryHomesPlace) {
      history.push(`/${account?.name}${route}/${placeId}/${propertyId}${location.search}`);
    } else if (route === Routes.LuxuryHomesList) {
      history.push(`/${account?.name}${route}${location.search}`);
    }
  };

  return (
    <div className="luxury-homes-back" onClick={onGoBack}>Back to Previous Page</div>
  );
}; 
